import Vue from 'vue';
import Vuex from 'vuex';

import LocalStorageProvider from '@/providers/storage/localStorage.provider';
import DexieProvider from '@/providers/storage/dexie.provider';

import googleDriveBackup from './modules/googleDriveBackup';
import images from './modules/images';
import modals from './modules/modals';
import notes from './modules/notes';
import preferences from './modules/preferences';
import tags from './modules/tags';

Vue.use(Vuex);

const STORAGE_PROVIDER_MAP = {
  LOCAL_STORAGE: LocalStorageProvider,
  DEXIE: DexieProvider,
};

export default new Vuex.Store({
  state: {
    preferenceProvider: 'LOCAL_STORAGE',

    storageProvider: null,
    storageProviderReady: false,

    query: {},
  },
  actions: {
    createStorageProvider({ commit, dispatch, state }) {
      commit('setStorageProvider',
        new STORAGE_PROVIDER_MAP[state.preferences.STORAGE_PROVIDER](this));
      dispatch('notes/init');
    },
  },
  mutations: {
    setStorageProvider(state, provider) {
      state.storageProvider = provider;
    },

    setStorageProviderReady(state, ready) {
      state.storageProviderReady = ready;
    },

    setRouteQuery(state, query) {
      state.routeQuery = query;
    },
  },
  modules: {
    googleDriveBackup,
    images,
    modals,
    notes,
    preferences,
    tags,
  },
});
